import React, { Fragment, useState } from 'react';
import CSLiveTripCardHeader from './cs-live-trip-card-header';
import CSLiveTripCardBody from './cs-live-trip-card-body';
import CSLiveTripCardFooter from './cs-live-trip-card-footer';
import '../styles.scss';
import { OrderType } from 'models/order.model';
import { ENUM_LIVE_CARD_MENU } from '../menu-config';
import RiderDetailsSideModal from 'pages/logistics/partners/partner-modals/rider-details-modal';

type Props = {
  order: OrderType;
  ridersAvailable: boolean;
  onSelectMenu: (menuKey: ENUM_LIVE_CARD_MENU) => void;
  onClick: () => void;
};

const CSLiveTripCard = ({ order, ridersAvailable, onSelectMenu, onClick }: Props) => {
  if (!order) return null;

  const [showRiderProfile, setShowRiderProfile] = useState(false);

  return (
    <Fragment>
      <div role='button' onClick={onClick} className='cursor-pointer live-trip-card relative'>
        <CSLiveTripCardHeader
          order={order}
          ridersAvailable={ridersAvailable}
          onSelectMenu={onSelectMenu}
        />
        <CSLiveTripCardBody order={order} setShowRiderProfile={setShowRiderProfile} />
        <CSLiveTripCardFooter order={order} />
      </div>

      {order?.rider ? (
        <RiderDetailsSideModal
          rider={order?.rider}
          show={showRiderProfile}
          onClose={() => setShowRiderProfile(false)}
        />
      ) : null}
    </Fragment>
  );
};

export default CSLiveTripCard;
